import React, { useState, useEffect } from "react";
import logo from "../../assets/images/logo/logo279.png";
import MenuBar from "../../container/MenuBar";
import MenuUserSearch from "../../container/MenuUserSearch";
import { MenuOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { Drawer, Dropdown, Space } from "antd";

const MENU_ITEMS = [
  { label: "Trang chủ", path: "/trang-chu" },
  { label: "Dịch vụ", path: "/dich-vu" },
  { label: "Liên hệ", path: "/lien-he" },
];
const TheHeader = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [open, setOpen] = useState(false);
  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };
  // Detect screen size and set isMobile accordingly
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768); // Consider anything below or equal to 768px as mobile
    };

    handleResize(); // Set initial value on load

    window.addEventListener("resize", handleResize); // Listen for window resize

    // Cleanup listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div className="the-header">
      <Link to="/trang-chu">
        <img src={logo} alt="logo-279" />
      </Link>
      {isMobile ? (
        <div className="navbar-menu-mobile">
          <div onClick={showDrawer}>
            <MenuOutlined />
          </div>
          <Drawer
            title=""
            onClose={onClose}
            open={open}
            className="drawer-menu-ecommerce"
            width={"70%"}
          >
            <div className="_contents">
              {MENU_ITEMS.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`menu-link `}
                  onClick={onClose}
                >
                  {item.label}
                </Link>
              ))}
            </div>
          </Drawer>
        </div>
      ) : (
        <>
          <MenuBar />
          <MenuUserSearch />
        </>
      )}
    </div>
  );
};

export default TheHeader;
